import { useEffect, useState } from "react";
import { CommunitySelectorModel } from "../models/CommunitySelectorModel"
import { CommunityFormEnum } from "../enums/CommunityFormEnum";
import { CommunitySubEnum } from "../enums/CommunitySubEnum";
import { useHistory } from "react-router-dom";
import clsx from "clsx";

type Props = {
    selection: CommunityFormEnum | null;
    onSelect: (id: CommunityFormEnum) => void;
    subs?: string;
    isEdited?: boolean;
}

export const CommunitySelector = ({ subs, selection, onSelect, isEdited }: Props) => {
    const history = useHistory();
    const [selectors, setSelectors] = useState<CommunitySelectorModel[]>([]);
    
    useEffect(() => {
        setSelectors([
            {
                id: CommunityFormEnum.OPEN_DISCUSSION,
                label: "Start Open Discussion",
                active: true,
                lock: isEdited ?? false
            },
            {
                id: CommunityFormEnum.MASTERMIND_CIRCLE,
                label: "Create Mastermind Circle",
                active: (subs === CommunitySubEnum.ElectiPlus),
                lock: isEdited ?? false
            }
        ]);
    }, [subs]);

    const _handleSelect = (selector: CommunitySelectorModel) => {
        if(!selector.active || selector.lock)
            return;
        onSelect(selector.id);
    }

    return (
        <div className="community-selector">
            {selectors.map((s, i) => (
                <div className={clsx("selector", {'disabled': !s.active && !s.lock})} key={i} onClick={() => _handleSelect(s)} >
                    {s.active ? (
                        <>
                            { selection === s.id ? (
                                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                                    <rect x="1" y="1" width="16" height="16" rx="8" stroke="#460107" stroke-width="2"/>
                                    <rect x="4" y="4" width="10" height="10" rx="5" fill="#460107"/>
                                </svg>
                            ): (
                                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                                    <rect x="1" y="1" width="16" height="16" rx="8" stroke="#DFDFDF" stroke-width="2"/>
                                </svg>
                            )}
                        </>
                    ): (
                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                            <g opacity="0.5">
                                <rect width="18" height="18" rx="9" fill="#E9E9E9"/>
                                <rect x="1" y="1" width="16" height="16" rx="8" stroke="#DFDFDF" stroke-width="2"/>
                            </g>
                        </svg>
                    )}
                    <span className="plan">{s.label}</span>
                    {!s.active && (
                        <div className="upgrade" onClick={() => history.push('/membership/change')}>
                            <div>
                                <span>Upgrade Membership</span>
                                <span>Electi+ membership required</span>
                            </div>
                            <div>
                                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="4" viewBox="0 0 14 4" fill="none">
                                    <path d="M8.5 0.378906L12 3.38306H0" stroke="white"/>
                                </svg>
                            </div>
                        </div>
                    )}
                </div>
            ))}
        </div>
    )
}